<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" focusable="false" viewBox="0 0 16 16">
  <path fill="currentColor" d="M8 0a8 8 0 011.083 15.927v-5.755h2.07l.326-2.113H9.083V6.903c0-.829.255-1.57.971-1.65l.132-.007h1.313V3.401l-.291-.036c-.28-.03-.711-.064-1.35-.064-1.86 0-2.978.956-3.05 3.123l-.004.228V8.06H4.825v2.113h1.98v5.74A8.002 8.002 0 018 0z"/>
</svg>
